import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function DailyMasterIllustration({
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3544">
      <div className="relative w-full h-full bg-gradient-to-br from-rose-100 to-amber-200 overflow-hidden" data-id="element-3545">
        {/* Background: Concentric target + streak ring */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3546">
          <circle cx="100" cy="95" r="66" fill="#FECDD3" opacity="0.5" data-id="element-3547" />
          <circle cx="100" cy="95" r="48" fill="#FDA4AF" opacity="0.5" data-id="element-3548" />
          <circle cx="100" cy="95" r="28" fill="#FB7185" opacity="0.5" data-id="element-3549" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-center justify-center pt-[8%]" data-id="element-3550">
          <div className="w-[64%] h-[64%] flex items-center justify-center" data-id="element-3551">
            <DjaySpecimen look={{
            variant
          }} size="hero" emotion={isUnlocked ? 'celebrating' : 'thinking'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-3552" />
          </div>
        </div>

        {/* Foreground: "100×" banner */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3553">
            <path d="M-10 150 Q100 176 210 150 L210 200 L-10 200 Z" fill="#E11D48" opacity="0.85" data-id="element-3554" />
            <text x="100" y="184" textAnchor="middle" fontFamily="sans-serif" fontSize="22" fontWeight="900" fill="white" data-id="element-3555">
              100×
            </text>
          </svg>}
      </div>
    </DjayIllustrationBase>;
}